// SEO Metadata Management

export interface SEOConfig {
    title: string;
    description: string;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    twitterTitle?: string;
    twitterDescription?: string;
}

// Default SEO config
const defaultConfig: SEOConfig = {
    title: 'Unilorin@50 Golden Jubilee Souvenir Shop',
    description: 'Official e-commerce platform for Unilorin@50 Golden Jubilee commemorative souvenirs. Pre-order exclusive merchandise celebrating the University of Ilorin\'s 50th anniversary.',
    ogImage: 'https://shop.unilorinsu.com/images/og-image.jpg'
};

// Update page title
export function updateTitle(title: string): void {
    document.title = title;

    // Update Open Graph title
    updateMetaTag('property', 'og:title', title);

    // Update Twitter title
    updateMetaTag('name', 'twitter:title', title);
}

// Update page description
export function updateDescription(description: string): void {
    updateMetaTag('name', 'description', description);
    updateMetaTag('property', 'og:description', description);
    updateMetaTag('name', 'twitter:description', description);
}

// Update Open Graph image
export function updateOGImage(imageUrl: string): void {
    updateMetaTag('property', 'og:image', imageUrl);
}

// Update meta tag
function updateMetaTag(attribute: string, name: string, content: string): void {
    let element = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement;

    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
    }

    element.setAttribute('content', content);
}

// Set SEO for specific page
export function setSEO(config: Partial<SEOConfig>): void {
    const finalConfig = { ...defaultConfig, ...config };

    updateTitle(finalConfig.title);
    updateDescription(finalConfig.description);

    if (finalConfig.ogImage) {
        updateOGImage(finalConfig.ogImage);
    }
}

// Page-specific SEO configurations
export const pageSEO = {
    home: {
        title: 'Shop Unilorin@50 Golden Jubilee Souvenirs | Official Store',
        description: 'Browse and pre-order exclusive limited-edition Unilorin@50 Golden Jubilee commemorative items. Pickup on November 27, 2025 at the Students\' Union Building.'
    },

    cart: {
        title: 'Shopping Cart | Unilorin@50 Souvenir Shop',
        description: 'Review your selected Unilorin@50 Golden Jubilee souvenirs and proceed to checkout.'
    },

    checkout: {
        title: 'Checkout | Unilorin@50 Souvenir Shop',
        description: 'Complete your order for Unilorin@50 Golden Jubilee souvenirs. Pay 50% now, balance on pickup.'
    },

    orderConfirmation: (orderId: string) => ({
        title: `Order Confirmation ${orderId} | Unilorin@50 Souvenir Shop`,
        description: 'Your Unilorin@50 Golden Jubilee souvenir order has been confirmed. Thank you for your purchase!'
    })
};
